module.exports = __webpack_public_path__ + "media/images/athletes/1804-e9762035ee8134a10deb8c70b4578fa6.png";